import { useParams } from "react-router-dom";
import Instructors from "../instructors/Instructors";

export default function ClassroomInstructors() {
  const params = useParams();

  return (
    <div>
      <Instructors classroomId={params.classroomId}></Instructors>
    </div>
  );
}
